<div class="sie-snackbar" data-testid="snackbar">
  <div [class]="'icon-' + data.type"></div>
  <div class="desc">
    <span class="strong">{{ data.title | translate: data.parameters }}</span>
    @if (data.desc) {
      <span>{{ data.desc | translate: data.parameters }}</span>
    }
  </div>
  <div class="icon-Close" (click)="close()"></div>
</div>
